import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addDosimetria, removeDosimetria } from "../../../../../../../../../../../redux/actions/resolucion";
import DosimetriaFormContainer from "./DosimetriaFormContainer";
import DosimetriaTable from "./DosimetriaTable";

const DosimetriaTableContainer = () => {
    const dispatch = useDispatch();
    const [openDosimetriaForm, setOpenDosimetriaForm] = useState(false);

    const data = useSelector((state) => state.resolucion.abmEquiposRadiologicos.dosimetria);
    const tiposDosimetria = useSelector((state) => state.resolucion.tiposDosimetria.data);
    const metodosDosimetria = useSelector((state) => state.resolucion.metodosDosimetria.data);

    const [dosimetria, setDosimetria] = useState(null);
    const handleOpenForm = (rowData) => {
        setOpenDosimetriaForm(true);
        setDosimetria(rowData);
    };

    const handleRemoveDosimetria = (row) => {
        dispatch(removeDosimetria(row));

    };
    const handleSubmitDosimetria = (values) => {
        dispatch(addDosimetria({
            ...values,
            nombreMetodoDosimetria: metodosDosimetria.find((v) => v.id === values.metodoDosimetria)?.nombre,
            nombreTipoDosimetria: tiposDosimetria.find((v) => v.id === values.tipoDosimetria)?.nombre,
        }, values.index));
        setOpenDosimetriaForm(false)
    };

    return (
        <>
            <DosimetriaTable
                handleDeleteDosimetria={handleRemoveDosimetria}
                handleOpenForm={handleOpenForm}
                data={data}
            />
            <DosimetriaFormContainer
                open={openDosimetriaForm}
                values={dosimetria}
                handleClose={() => setOpenDosimetriaForm(false)}
                handleSubmit={handleSubmitDosimetria}
            />
        </>
    )

}


export default DosimetriaTableContainer;